import React from 'react';
import {
  Table,
  Tag,
  Input,
  Typography,
  Spin,
  DatePicker,
  Button,
} from 'antd';
import { StarOutlined, StarFilled } from '@ant-design/icons';
import dayjs from 'dayjs';
import { ColumnsType } from 'antd/es/table';
import type { RangePickerProps } from 'antd/es/date-picker';
import { IRSchedule } from '../types';

interface TableViewProps {
  irSchedules: IRSchedule[];
  isLoading: boolean;
  isMobile: boolean;
  dateRange: [dayjs.Dayjs, dayjs.Dayjs];
  watchedCompanies: string[];
  onDateRangeChange: (dates: [dayjs.Dayjs, dayjs.Dayjs] | null) => void;
  onCompanySearch: (value: string) => void;
  onToggleWatch: (company: string) => void;
}

const TableView: React.FC<TableViewProps> = ({
  irSchedules,
  isLoading,
  isMobile,
  dateRange,
  watchedCompanies,
  onDateRangeChange,
  onCompanySearch,
  onToggleWatch,
}) => {
  const handleDateRangeChange: RangePickerProps['onChange'] = (dates) => {
    if (dates) {
      onDateRangeChange(dates as [dayjs.Dayjs, dayjs.Dayjs]);
    } else {
      onDateRangeChange(null);
    }
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          gap: 10,
          justifyContent: 'center',
          marginBottom: 20,
          flexWrap: 'wrap',
        }}
      >
        <DatePicker.RangePicker
          value={dateRange}
          onChange={handleDateRangeChange}
          style={{ width: 300 }}
        />
        <Input.Search
          onChange={(e) => onCompanySearch(e.target.value)}
          style={{ width: 300 }}
          placeholder="회사명 검색"
        />
      </div>

      <Table
        size="small"
        columns={
          [
            {
              title: '관심',
              dataIndex: 'company',
              width: 50,
              render: (_: unknown, record: IRSchedule) => (
                <Button
                  type="text"
                  icon={
                    watchedCompanies.includes(record.company) ? (
                      <StarFilled style={{ color: '#ffd700' }} />
                    ) : (
                      <StarOutlined />
                    )
                  }
                  onClick={() => onToggleWatch(record.company)}
                />
              ),
            },
            {
              title: '회사',
              dataIndex: 'company',
              width: isMobile ? 100 : 150,
            },
            {
              title: '제목',
              dataIndex: 'title',
              render: (text: string, record: IRSchedule) => (
                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                  {text}
                  {record.type && <Tag>{record.type}</Tag>}
                </div>
              ),
            },
            {
              title: '날짜',
              dataIndex: 'date',
              width: 120,
            },
            {
              title: '시간',
              dataIndex: 'time',
              width: 100,
            },
          ] as ColumnsType<IRSchedule>
        }
        dataSource={irSchedules}
        loading={{
          spinning: isLoading,
          indicator: (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 300,
                gap: 20,
              }}
            >
              <Spin tip="데이터를 불러오는 중입니다... " size="large" />
              <Typography.Text
                style={{
                  width: 300,
                  display: 'block',
                }}
              >
                IR 일정을 불러오는 중입니다...
              </Typography.Text>
            </div>
          ),
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          defaultPageSize: 20,
        }}
      />
    </div>
  );
};

export default TableView;
